import { render } from "./BookedAppointments.vue?vue&type=template&id=17da2fd0&scoped=true"
import script from "./BookedAppointments.vue?vue&type=script&lang=js"
export * from "./BookedAppointments.vue?vue&type=script&lang=js"

import "./BookedAppointments.vue?vue&type=style&index=0&id=17da2fd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17da2fd0"]])

export default __exports__